import { withDevtools } from '@angular-architects/ngrx-toolkit';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { removeEntity, setAllEntities, upsertEntity, withEntities } from '@ngrx/signals/entities';
import Brand from 'mbs-ui-shared@models/Brand';

const selectId = (brand: Brand) => brand.id!;

export const BrandsStore = signalStore(
  { providedIn: 'root' },
  withDevtools('BrandsStore'),
  withEntities<Brand>(),
  withState({ loading: false, loaded: false }),
  withMethods((store) => ({
    setLoading(loading: boolean): void {
      patchState(store, { loading });
    },
    setAll(brands: Brand[]): void {
      patchState(store, setAllEntities(brands, { selectId }), { loaded: true, loading: false });
    },
    upsertOne(brand: Brand): void {
      patchState(store, upsertEntity(brand, { selectId }));
    },
    removeOne(id: string): void {
      patchState(store, removeEntity(id));
    }
  }))
);

export type BrandsStoreType = InstanceType<typeof BrandsStore>;
